module.exports = __webpack_public_path__ + "static/media/precision_mobile.3da3a30d.png";